const DEFAULT_STATE = {
    beneficiaryName: '',
    transfereeName: '',
};


const fnList = {
    UPDATE_BENEFICIARY_NAME: (state, payload) => ({
        ...state,
        beneficiaryName: payload,
    }),
    UPDATE_TRANSFEREE_NAME: (state, payload) => ({
        ...state,
        transfereeName: payload,
    }),
};

export default (state = DEFAULT_STATE, { type, payload }) => {
    const fn = fnList[type];
    if (typeof fn === 'function') {
        return fn(state, payload);
    }
    return state;
};



//////////////////
// WEBPACK FOOTER
// ./src/reducers/formReducers.js
// module id = 1070
// module chunks = 0